import React from 'react'
// nodejs library to set properties for components
import PropTypes from 'prop-types'

import Img from 'gatsby-image'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import Hidden from '@material-ui/core/Hidden'
import Grid from '@material-ui/core/Grid'
import withSection from 'components/withSection'
import ListHeader from 'components/List/ListHeader'

const aboutStyle = theme => {
  return {
    roundImage: {
      ...theme.utils.image.round,
    },
  }
}

const About = ({ classes, image, ...rest }) => {
  return (
    <Grid container alignItems="center">
      <Hidden xsDown>
        <Grid item sm={3}>
          <Img
            title="Adrien POLY"
            alt="Adrien POLY"
            fixed={image.childImageSharp.fixed}
            critical={true}
            className={classes.roundImage}
          />
        </Grid>
      </Hidden>
      <Grid item xs={12} sm={9}>
        <ListHeader {...rest} />
      </Grid>
    </Grid>
  )
}

About.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withSection({ id: 'about' })(withStyles(aboutStyle)(About))
